import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ImagesFallbackModule } from 'src/app/project/directives/images-fallback/images-fallback.module';
import { SecureSrcModule } from 'src/app/project/directives/secure-src/secure-src.module';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { EActivityPropName } from '../../../../../../shared/enums/activity-prop-name.enum';

@Component({
  selector: 'pp-attachment-deleted-activity',
  templateUrl: './attachment-deleted-activity.component.html',
  styleUrls: ['../activity-change.component.scss'],
  imports: [CommonModule, PipesModule, ImagesFallbackModule, SecureSrcModule],
})
export class AttachmentDeletedActivityComponent {
  @Input() ppChange;

  EActivityPropName = EActivityPropName;
  EIconPath = EIconPath;

  constructor() {}
}
